// FETCH ALL PROPERTIES FROM IRONING_AND_PACKING_INWARD DETAILS
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST';
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS';
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM IRONING_AND_PACKING_INWARD DETAILS BY ID
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_REQUEST = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_REQUEST';
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_SUCCESS = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_SUCCESS';
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_FAILURE = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_FAILURE';

// FETCH ALL PROPERTIES FROM IRONING_AND_PACKING_INWARD DETAILS BY ID
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_REQUEST = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_REQUEST';
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_SUCCESS = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_SUCCESS';
export const FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_FAILURE = 'FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_FAILURE';

// CREATE PROPERTIES FOR IRONING_AND_PACKING_INWARD DETAILS
export const CREATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST = 'CREATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST';
export const CREATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS = 'CREATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS';
export const CREATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE = 'CREATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_IRONING_AND_PACKING_INWARD_DETAILS = 'CREATE_USER_FORM_IRONING_AND_PACKING_INWARD_DETAILS';

// UPDATE PROPERTIES FOR IRONING_AND_PACKING_INWARD DETAILS
export const UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST = 'UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST';
export const UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS = 'UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS';
export const UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE = 'UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE';

// FETCH SINGLE IRONING_AND_PACKING_INWARD_DETAILS
export const FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE';

// DELETE PROPERTIES FOR IRONING_AND_PACKING_INWARD DETAILS
export const DELETE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST = 'DELETE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST';
export const DELETE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS = 'DELETE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS';
export const DELETE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE = 'DELETE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE';

// USERFORM RESET

export const IRONING_AND_PACKING_INWARD_DETAILS_USERFORM_RESET = 'IRONING_AND_PACKING_INWARD_DETAILS_USERFORM_RESET';

export const IRONING_AND_PACKING_INWARD_DETAILS_PO_DETAILS_DISABLED = 'IRONING_AND_PACKING_INWARD_DETAILS_PO_DETAILS_DISABLED';
export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID =
    'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID';
export const SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID =
    'SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID';
